export default __webpack_public_path__ + "static/media/goodreads1.42f2f75a.png";